import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import { VeiculosModel } from "./veiculos.model";
import { VeiculosService } from './veiculos.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";


@Component({
  selector: 'app-veiculos-form',
  templateUrl: './veiculos-form.component.html'
})
export class VeiculosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  veiculo: VeiculosModel = new VeiculosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  mascaraPlaca = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, '-', /\d/, /[a-zA-Z0-9]/, /\d/, /\d/];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private veiculosService: VeiculosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_veiculo: [],
      marca: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(45)
      ]],
      modelo: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(45)
      ]],
      placa: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(8)
      ]],
      renavam: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(20)
      ]],
      troca_oleo: ['', [
        Validators.required
      ]],
      km_troca_oleo: ['', [
        Validators.required
      ]],
      extintor: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      validade_extintor: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      trocar_oleo_cada_km: ['', [
        Validators.required
      ]],
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_veiculo'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.editarVeiculo');
      } else {
        this.title = id ? this.func.traduzir('front.visualizarVeiculo') : this.func.traduzir('front.cadastrarNovoVeiculo');
      }

      if (!id) {
        return;
      }

      this.veiculosService.getById(id)
        .subscribe(
          json => {
            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }

            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarVeiculo') + ': ' + json.Payload[0].modelo;
            } else {
              this.title = this.func.traduzir('front.visualizarVeiculo') + ': ' + json.Payload[0].modelo;
            }
            this.veiculo = json.Payload[0]
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.veiculo;//this.form.value;

    if (values.id_veiculo) {
      result = this.veiculosService.editar(values, values.id_veiculo);
    } else {
      result = this.veiculosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'veiculos']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }

  // evento quando a placa é alterada
  changePlaca(e) {
    this.veiculo.placa = e.toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/veiculos/veiculos-form.component.ts